import { Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-comingsoon",
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: "./comingsoon.component.html",
  styleUrl: "./comingsoon.component.scss",
})
export class ComingsoonComponent {
  type = "";

  constructor(private route: ActivatedRoute) {
    this.type = this.route.snapshot.paramMap.get("type") || "";
  }
}